// import React from "react";
// import {
//   FaTwitter,
//   FaFacebookF,
//   FaYoutube,
//   FaEnvelope,
//   FaPhone
// } from "react-icons/fa";
// import "../styles/FooterTabComponent.css";

// const FooterTabComponent = () => {
//   return (
//     <footer className="footer-wrapper">
//       <div className="footer-top">
//         <div className="footer-section">
//           <h4>About Us</h4>
//           <ul>
//             <li><a href="https://www.fipi.org.in/history.php">History</a></li>
//             <li>We Represent</li>
//             <li>Vision</li>
//             <li>Governing Council Members</li>
//             <li>Governing Council Meeting</li>
//             <li>Leadership Team</li>
//             <li>Contact Us</li>
//           </ul>
//         </div>

//         <div className="footer-section">
//           <h4>Quick Access</h4>
//           <ul>
//             <li>Members</li>
//             <li>FIPI Speaks</li>
//             <li>Awards 2023</li>
//             <li>Recommendations</li>
//             <li>Meetings</li>
//             <li>Past Events</li>
//             <li>Upcoming Events</li>
//           </ul>
//         </div>

//         <div className="footer-section">
//           <h4>Company</h4>
//           <address>
//             3rd Floor, PHD House, 4/2,<br />
//             Siri Institutional Area,<br />
//             August Kranti Marg,<br />
//             New Delhi - 110 016
//           </address>
//           <p><FaEnvelope /> dg.sectt@fipi.org.in</p>
//           <p><FaPhone /> +91-11-40886000</p>
//         </div>

//         <div className="footer-section">
//           <h4>Follow Us</h4>
//           <div className="social-icons">
//             <FaTwitter />
//             <FaFacebookF />
//             <FaYoutube />
//           </div>
//         </div>
//       </div>

//       <div className="footer-bottom">
//         <div className="footer-links">
//           <a href="/sitemap">Sitemap</a>
//           <a href="/terms-of-use">Terms of use</a>
//           <a href="/privacy-policy">Privacy Policy</a>
//           <a href="/refund-policy">Refund Policy</a>
//         </div>
//         <p className="copyright">Copyright © {new Date().getFullYear()} FIPI</p>
//       </div>
//     </footer>
//   );
// };

// export default FooterTabComponent;

import React from "react";
import {
  FaTwitter,
  FaFacebookF,
  FaYoutube,
  FaEnvelope,
  FaPhone
} from "react-icons/fa";
import "../styles/FooterTabComponent.css";
 
const FooterTabComponent = () => {
  return (
    <footer className="footer-wrapper">
      <div className="footer-top">
        <div className="footer-section">
          <h4>About Us</h4>
          <ul>
            <li><a href="https://www.fipi.org.in/history.php">History</a></li>
           
            <li><a href="https://www.fipi.org.in/we-represent.php">We Represent</a></li>
            <li><a href="https://www.fipi.org.in/vision.php">Vision</a></li>
            <li><a href="https://www.fipi.org.in/governing-council-members.php">Governing Council Members</a></li>
            <li><a href="https://www.fipi.org.in/governing-council-meetings.php">Governing Council Meeting</a></li>
            <li><a href="https://www.fipi.org.in/leadership-team.php">Leadership Team</a></li>
            <li><a href="https://www.fipi.org.in/contact-us.php">Contact Us</a></li>
          </ul>
        </div>
 
        <div className="footer-section">
          <h4>Quick Access</h4>
          <ul>
            <li><a href="https://www.fipi.org.in/members.php">Members</a></li>
            <li><a href="https://www.fipi.org.in/in-news1.php">FIPI Speaks</a></li>
            <li><a href="https://award.fipi.org.in/fipiawards/">Awards 2025</a></li>
            <li><a href="https://www.fipi.org.in/recommendations.php">Recommendations</a></li>
            <li><a href="https://www.fipi.org.in/committees-meetings.php"> Meetings</a></li>
            <li><a href="https://www.fipi.org.in/events.php">Past Events</a></li>
            <li><a href="https://www.fipi.org.in/upcoming-events.php"> Upcoming Events</a></li>
          </ul>
        </div>
 
        <div className="footer-section">
          <h4>Company</h4>
          <address>
            J-105, Tower-J, First Floor,<br /><br/>
           World Trade Centre,<br /><br/>
            Nauroji Nagar,<br /><br/>
           New Delhi-110029
          </address>
          <br/>
          <p><FaEnvelope /> dg.sectt@fipi.org.in</p>
          <br/>
          <p><FaPhone /> +91-11-40886000</p>
        </div>
 
        <div className="footer-section">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <FaTwitter />
            <FaFacebookF />
            <FaYoutube />
          </div>
        </div>
      </div>
 
      <div className="footer-bottom">
        <div className="footer-links">
          <a href="https://www.fipi.org.in/sitemap.php">Sitemap</a>
          <a href="https://www.fipi.org.in/term-of-use.php">Terms of use</a>
          <a href="https://www.fipi.org.in/privacy-policy.php">Privacy Policy</a>
          <a href="https://www.fipi.org.in/refund-and-cancellation.php">Refund Policy</a>
        </div>
        <p className="copyright">Copyright © {new Date().getFullYear()} FIPI</p>
      </div>
    </footer>
  );
};
 
export default FooterTabComponent; 